import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch, useSelector } from "react-redux";

import { loginSchema } from "../../schemas";
import { loginUser } from "../../features/userSlice";
import InputField from "../../components/form/InputField";
import AuthRedirect from "../../components/hoc/AuthRedirect";
import { useNotification } from "../../components/notification/NotificationContainer";
import loadStatus from "../../util/loadStatus";

const Login = () => {
  const addNotification = useNotification();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginLoad = useSelector((state) => state.user.load.loginUser);

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      await dispatch(loginUser(data)).unwrap();
      addNotification("Logged in Successfully", "success");
      return navigate("/dashboard");
    } catch (err) {
      if (!err.sucess) {
        addNotification(err.message, "error");
      }
    }
  };

  return (
    <AuthRedirect>
      <div className="auth-container">
        <div className="auth-content ">
          <div className=" auth-inner-content ">
            <h3 className="auth-title">Sign In</h3>
            <p>{errors.root?.message}</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <InputField
                register={register}
                errors={errors.email}
                label="Email"
                name="email"
                placeholder="user@example.com"
                type="email"
              />
              <InputField
                register={register}
                errors={errors.password}
                label="Password"
                name="password"
                placeholder="user@example.com"
                type="password"
              />
              <div className="flex justify-end items-center">
                <Link
                  className="text-xs text inline-block text-right pb-8 text-primary"
                  to="/forgot-password"
                >
                  Forgot password?
                </Link>
              </div>
              <button
                className="auth-btn"
                type="submit"
                disabled={loginLoad === loadStatus.loading}
              >
                Sign In
              </button>
            </form>
            <div className="py-10 text-center text-xs">
              <p>
                <span className="text-text-1/50">Don't have an account? </span>
                {/* <Link className="text-primary" to="/register">
                  Register here
                </Link> */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </AuthRedirect>
  );
};

export default Login;
